import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from "react";
import { _showToast } from "../../../../../toastHelper";
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const About = forwardRef(function DemoDetails(props, ref) {
  const [imageKey, setImageKey] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const thumbnailRef = useRef();

  useEffect(() => {
    resetData();
    if (props.data) {
      setDescription(props.data.description);
      setImageKey(props.data.imageKey);
      thumbnailRef?.current?.setThumbnail(
        props.data.image && props.data.image != "" ? props.data.image : null
      );
      thumbnailRef?.current?.setFileContent(props.data.imageFile);
    }
  }, [props.data]);

  const resetData = () => {
    setDescription(
      "We have the expertise to deliver stunning photography that makes your memories shine. We can also take the show on the road to produce top quality visual treat on location. If you need more than just photography, don't forget that we're the one-stop shop photostudio in and out of Hyderabad. We can handle your entire project from beginning to end - have the talent, experience, staff, and equipment to get the job rightly done. Let's hang onto these moments for as long as we can and hang them on our walls. Whether it's an on-location shoot, candid captures, little mischievous uncooperative photo session with your kids or everything from pre-weddings, and concerts to corporate events and retreats - we are flexible in every event photography technique. Besides techniques, we put our heart and soul together freeze on the spot to define the true personality of you and make the story unique. Which means, we are physically and mentally focused and switched on at all times. We, the best candid photograhers in Hyderabad, believe there is nothing more interesting than figuring out the tiny quirks of the people you care. We are here to do the job - give us the babies who play with their ma's hair or the little wild one who is never still."
    );
    thumbnailRef?.current?.setThumbnail(null);
    thumbnailRef?.current?.setFileContent(null);
  };

  const validate = () => {
    const errors = {};
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getData = () => {
    return {
      description: description,
      image: thumbnailRef?.current?.getThumbnail() ?? null,
      imageFile: thumbnailRef?.current?.getImageFile() ?? null,
      imageKey: imageKey,
    };
  };

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate,
  }));

  return (
    <>
      <div
        className="content"
        style={{ display: "block", visibility: "visible" }}
      >
        <div className="content-header mb-3">
          <div className="sec-titler">
            <h2 className="text-primary">About Details</h2>
            <div className="title-shape"></div>
          </div>
        </div>
        <form>
          <div className="row">
            <div className="col-sm-6 mt-4">
              <label className="form-label">About Us (Upto 2500 Characters)</label>
              <textarea
                style={{ height: "350px", resize: "none" }}
                className="form-control"
                placeholder="Enter description"
                value={description}
                maxLength={2500}
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
            <div className="col-sm-6 mt-4">
              <label className="form-label" htmlFor="thumbnail">
                 Image{" "}
                <small className="text-gray">
                  (Max Allowable File Size: 1MB,Dimensions: 750px x 750px)
                </small>
              </label>
              <ImageBrowse
                elementId="featuredImage"
                ref={thumbnailRef}
                imageType="profile"
                imageKey={imageKey}
                setImageKey={setImageKey}
                imageDelete={props.imageDelete}
              />
            </div>
          </div>

          <StepperNavigationButtons
            index={props.index}
            steps={props.steps}
            navigate={props.navigate}
          />
        </form>
      </div>
    </>
  );
});

export default About;
